import { CurrencyCode } from '@cash-web/protos/squareup/common/currency_codes.pb'

export const getCurrencyPrefix = (currency_code: CurrencyCode) => {
  switch (currency_code) {
    case CurrencyCode.USD:
      return '$'
    case CurrencyCode.GBP:
      return '£'
    default:
      throw new Error(`Currency prefix - unsupported currency code: ${currency_code}`)
  }
}
